import axios from 'axios';

// All requests go through Vercel's API routes
const API_BASE_URL = '/api';

// Create an axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 second timeout for DALL-E
  headers: {
    'Content-Type': 'application/json',
  }
});

export const generateImage = async (prompt) => {
  try {
    const response = await api.post('/generate-image', {
      prompt: prompt,
      size: '1024x1024',
    }, {
      timeout: 60000, // Explicit timeout for this request
      validateStatus: function (status) {
        return status >= 200 && status < 500; // Accept all responses to handle them properly
      }
    });
    
    if (response.status >= 400) {
      throw new Error(response.data.error || 'Failed to generate image');
    }
    
    return {
      imageUrl: response.data.imageUrl,
      revisedPrompt: response.data.revisedPrompt
    };
  } catch (error) {
    console.error('Error generating image:', {
      message: error.message,
      code: error.code,
      status: error.response?.status,
    });
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out. Please try again.');
    } else if (error.response?.status === 401) {
      throw new Error('API key is invalid or missing.');
    } else if (error.response?.status === 429) {
      throw new Error('Rate limit exceeded. Please try again later.');
    } else {
      throw new Error('Failed to generate image. Please try again.');
    }
  }
};

export const fetchPreloadedImage = async (word, category) => {
  try {
    const response = await api.get('/preloaded-images', {
      params: { word, category }
    });
    return response.data.imagePath;
  } catch (error) {
    console.error('Error fetching preloaded image:', {
      message: error.message,
      code: error.code,
      status: error.response?.status,
    });
    throw error;
  }
};

export const preloadImage = (imagePath) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = imagePath;
  });
};